module.exports = __webpack_public_path__ + "static/img/arrow-up-gray.efa25bdc.svg";